import classNames from 'classnames';
import Link from 'next/link';
import React, {ReactElement, useCallback, useEffect, useMemo, useRef} from 'react';

import CropAnimations from '../../../../resources/crop-animations';
import LottieAnimation from '../../../game/components/LottieAnimation';
import {CropFamilyId} from '../../resources/cropFamilies';

type Props = {
  id: CropFamilyId;
  step: number;
  name: string;
  onComplete: (id: CropFamilyId, step: number) => void;
};

const CropAnimationListItem = ({id, step, name, onComplete}: Props): ReactElement => {
  const stepRef = useRef(step);
  useEffect(() => {
    stepRef.current = step;
  }, [step]);

  const actualStep = Math.min(step, CropAnimations[id].length - 1);

  const handleComplete = useCallback(() => {
    onComplete(id, stepRef.current);
  }, [id, onComplete]);

  const animation = useMemo(() => CropAnimations[id]?.[actualStep], [id, actualStep]);

  return (
    <li key={id} className={'relative w-[140px] h-full flex-none flex flex-col list-none justify-between text-center'}>
      <LottieAnimation
        className="absolute bottom-0 left-1/2 right-0 h-[480px] w-[300px] -translate-x-1/2"
        animation={animation}
        loop={false}
        contain={true}
        autoplay={false}
        onComplete={handleComplete}
      />
      <Link
        href={`/crops/${id}`}
        className={classNames(
          'absolute top-0 left-0 right-0 z-10 w-full text-primary-800 text-sm font-semibold fv-outline-internal',
          'border-thin border-white rounded-[1rem] py-4 px-8',
          'hover:no-text-shadow hover:border-primary-300'
        )}
      >
        {name}
      </Link>
    </li>
  );
};

export default CropAnimationListItem;
